import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Moment from 'moment';
import { extendMoment } from 'moment-range';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import IconButton from 'components/common/IconButton';
import IconArrowHeadLeft from 'components/icons/IconArrowHeadLeft';
import IconArrowHeadRight from 'components/icons/IconArrowHeadRight';

import dateFormat from 'config/dateFormat';

import * as validate from 'utils/validate';

const moment = extendMoment(Moment);

const styles = theme => ({
  root: {
    display: 'inline-block',
  },
  iconArrowHead: {
    width: 7.4,
    height: 12,
    color: theme.palette.grey[600],
  },
});

const ScheduleCalendarFilterPrevNextControls = ({
  className, disabled, variant, classes, ...otherProps
}) => {
  const dateFrom = moment(otherProps['Date of Delivery From'].input.value, dateFormat);
  const dateTo = moment(otherProps['Date of Delivery To'].input.value, dateFormat);
  let arrowsDisabled = validate.date(otherProps['Date of Delivery From'].input.value)
    || validate.date(otherProps['Date of Delivery To'].input.value);
  if (!arrowsDisabled) {
    switch (variant.input.value) {
      case 'month': {
        if (!dateFrom.clone().startOf('month').isSame(dateFrom)
          || dateTo.clone().add(1, 'days').diff(dateFrom, 'months', true) !== 1) {
          arrowsDisabled = true;
        }
        break;
      }
      case 'week': {
        if (!dateFrom.clone().startOf('week').isSame(dateFrom)
          || dateTo.clone().add(1, 'days').diff(dateFrom, 'weeks', true) !== 1) {
          arrowsDisabled = true;
        }
        break;
      }
      case 'day': {
        if (!dateFrom.clone().startOf('day').isSame(dateTo.clone().startOf('day'))) {
          arrowsDisabled = true;
        }
        break;
      }
      default:
    }
  }
  if (!otherProps['Date of Delivery From'].input.value
    && !otherProps['Date of Delivery To'].input.value) {
    return '';
  }
  return (
    <div className={classNames(classes.root, className)}>
      <Grid
        container
        justify="space-between"
        alignItems="center"
        wrap="nowrap"
        spacing={8}
      >
        <Grid item>
          <IconButton
            {...!disabled ? {
              onClick: () => {
                if (variant.input.value === 'day') {
                  otherProps['Date of Delivery From'].input
                    .onChange(dateFrom.clone().subtract(1, 'days').format(dateFormat));
                  otherProps['Date of Delivery To'].input
                    .onChange(dateTo.clone().subtract(1, 'days').format(dateFormat));
                } else if (variant.input.value === 'week') {
                  otherProps['Date of Delivery From'].input
                    .onChange(dateFrom.clone().subtract(1, 'week').format(dateFormat));
                  otherProps['Date of Delivery To'].input
                    .onChange(dateTo.clone().subtract(1, 'week').format(dateFormat));
                } else if (variant.input.value === 'month') {
                  const newDateFrom = dateFrom.clone().subtract(1, 'month');
                  const newDateTo = newDateFrom.clone().endOf('month');
                  otherProps['Date of Delivery From'].input
                    .onChange(newDateFrom.format(dateFormat));
                  otherProps['Date of Delivery To'].input
                    .onChange(newDateTo.format(dateFormat));
                }
              },
            } : {
              onClick: () => {},
            }}
            {...variant.input.value === 'day' && !arrowsDisabled ? { tooltipContent: 'Previous Day' } : {}}
            {...variant.input.value === 'week' && !arrowsDisabled ? { tooltipContent: 'Previous Week' } : {}}
            {...variant.input.value === 'month' && !arrowsDisabled ? { tooltipContent: 'Previous Month' } : {}}
            disabled={arrowsDisabled}
          >
            <IconArrowHeadLeft className={classes.iconArrowHead} />
          </IconButton>
          <IconButton
            {...!disabled ? {
              onClick: () => {
                if (variant.input.value === 'day') {
                  otherProps['Date of Delivery From'].input
                    .onChange(dateFrom.clone().add(1, 'days').format(dateFormat));
                  otherProps['Date of Delivery To'].input
                    .onChange(dateTo.clone().add(1, 'days').format(dateFormat));
                } else if (variant.input.value === 'week') {
                  otherProps['Date of Delivery From'].input
                    .onChange(dateFrom.clone().add(1, 'week').format(dateFormat));
                  otherProps['Date of Delivery To'].input
                    .onChange(dateTo.clone().add(1, 'week').format(dateFormat));
                } else if (variant.input.value === 'month') {
                  const newDateFrom = dateFrom.clone().add(1, 'month');
                  const newDateTo = newDateFrom.clone().endOf('month');
                  otherProps['Date of Delivery From'].input
                    .onChange(newDateFrom.format(dateFormat));
                  otherProps['Date of Delivery To'].input
                    .onChange(newDateTo.format(dateFormat));
                }
              },
            } : {
              onClick: () => {},
            }}
            {...variant.input.value === 'day' && !arrowsDisabled ? { tooltipContent: 'Next Day' } : {}}
            {...variant.input.value === 'week' && !arrowsDisabled ? { tooltipContent: 'Next Week' } : {}}
            {...variant.input.value === 'month' && !arrowsDisabled ? { tooltipContent: 'Next Month' } : {}}
            disabled={arrowsDisabled}
          >
            <IconArrowHeadRight className={classes.iconArrowHead} />
          </IconButton>
        </Grid>
      </Grid>
    </div>
  );
};

ScheduleCalendarFilterPrevNextControls.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.shape({
    input: PropTypes.shape({
      value: PropTypes.oneOf(['day', 'week', 'month', '']).isRequired,
    }).isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconArrowHead: PropTypes.string.isRequired,
  }).isRequired,
};

ScheduleCalendarFilterPrevNextControls.defaultProps = {
  disabled: false,
  className: '',
};

export default withStyles(styles)(ScheduleCalendarFilterPrevNextControls);



// WEBPACK FOOTER //
// ./src/components/schedule/ScheduleCalendarFilter/ScheduleCalendarFilterPrevNextControls.js